import React from "react";

function Itinerance(props) {
  return (
    <div>
      <h1>L'itinérance</h1>

      <h4>
        Comment nous nous déplaçons? Dans quelle zone? Ne vous posez plus de
        questions, on vous dit tout!
      </h4>
      <p>
        <span>
          <strong>Le camion:</strong>
        </span>
        <br />
        Ce camion, c&#8217;est lui qui promène les jeux et jouets partout ! Il
        n&#8217; a pas d&#8217;aménagement spécifique &#8220;ludobus&#8221;. Il
        nous permet de transporter jusqu&#8217;à 9 m3 de matériel ludique !
      </p>
      <p>
        
      </p>
      <p>
        <span>
          <strong>Notre zone de déplacement:</strong>
        </span>
      </p>
      <p>
        Nous avons ciblé un territoire d&#8217;environ 30 kilomètres autour du
        mais pour le Jeu , il n&#8217;y a pas de frontières
        infranchissables ! Par contre, il se peut que vous ayez déjà une
        ludothèque à proximité &#8230; voici les autres ludos près de chez vous
        :
      </p>
      
    </div>
  );
}

export default Itinerance;
